import script from "./QueueLeafWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./QueueLeafWidget.vue?vue&type=script&setup=true&lang=ts"

import "./QueueLeafWidget.vue?vue&type=style&index=0&id=2dde35e3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dde35e3"]])

export default __exports__